import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "RemoveFavorite" })
export default class RemoveFavorite extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public validationErrors: any[] = [];

    @Prop() readonly favoriteId: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async removeProfileFavorite() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.ProfileFavorite_FavoriteRemoveById, { id: this.favoriteId });

            this.$emit("updateData");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};